import { Button, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutStatusListToolPanel extends Layout {
    buttonManuallyTransmit: Button;
    panel1: Panel;
    panel3: Panel;
    panelButtons: Panel;
}
